import { render, staticRenderFns } from "./LanguageTwo.vue?vue&type=template&id=59645c70&scoped=true&"
import script from "./LanguageTwo.vue?vue&type=script&lang=js&"
export * from "./LanguageTwo.vue?vue&type=script&lang=js&"
import style0 from "./LanguageTwo.vue?vue&type=style&index=0&id=59645c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59645c70",
  null
  
)

export default component.exports